import type { Row } from '~/composables/useDb'

/** Écritures dans l'API Java, avec mise à jour de la base chargée en mémoire (l'équivalent de `db.xxx.push(...)` de la maquette). */
export async function apiCreate(collection: string, body: object): Promise<Row> {
  try {
    const saved = await $fetch<Row>(`/api/${collection}`, { method: 'POST', body })
    const db = useDb()
    db.value = { ...db.value, [collection]: [...(db.value[collection] ?? []), saved] }
    return saved
  }
  catch (e) {
    await handleAuthError(e)
    throw e
  }
}

export async function apiUpdate(collection: string, id: string, body: object): Promise<Row> {
  try {
    const saved = await $fetch<Row>(`/api/${collection}/${id}`, { method: 'PUT', body })
    const db = useDb()
    db.value = { ...db.value, [collection]: (db.value[collection] ?? []).map(r => (r.id === id ? saved : r)) }
    return saved
  }
  catch (e) {
    await handleAuthError(e)
    throw e
  }
}

export async function apiRemove(collection: string, id: string): Promise<void> {
  try {
    await $fetch(`/api/${collection}/${id}`, { method: 'DELETE' })
    const db = useDb()
    db.value = { ...db.value, [collection]: (db.value[collection] ?? []).filter(r => r.id !== id) }
  }
  catch (e) {
    await handleAuthError(e)
    throw e
  }
}

/** Sans le champ `id`, que les requêtes de l'API n'attendent pas. */
export function withoutId(row: Row): Record<string, unknown> {
  const { id: _id, ...rest } = row
  return rest
}
